import { ReactElement, useMemo, useCallback } from 'react';

import { AdminReportItemsInProgressDriver } from '~services/admin/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';
import { getDefaultAvatar } from '~utils/user';
import { DEFAULT_UUIID_EMPTY } from '~constants/commons';

import { useDashboardVariantV2CarrierContentInTransitTrackingContext } from '../../../Context';

type DriversDeliveryExtraData = Pick<
  AdminReportItemsInProgressDriver,
  'routeId' | 'driverId' | 'vehicleId'
>;

const DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabDrivers =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedRouteId: {
          value: selectedRouteId,
          setValue: setSelectedRouteId,
        },
      },
    } = useDashboardVariantV2CarrierContentInTransitTrackingContext();

    const driversDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<DriversDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.itemsInProgressByDriver) return [];

      return tabsData.itemsInProgressByDriver.map((driver) => ({
        label: driver.driverName,
        totalCount: driver.totalItemsInProgress,
        standarCount: driver.totalItemsInProgressNoFlex,
        flexCount: driver.totalItemsInProgressFlex,
        avatar: {
          src: getDefaultAvatar(driver.avatarUrl || undefined),
          alt: driver.driverName,
        },
        extraData: {
          routeId: driver.routeId,
          driverId: driver.driverId,
          vehicleId: driver.vehicleId,
        },
        isSelected:
          driver.driverId === DEFAULT_UUIID_EMPTY
            ? selectedRouteId === DEFAULT_UUIID_EMPTY
            : selectedRouteId === driver.routeId,
      }));
    }, [tabsData?.itemsInProgressByDriver, selectedRouteId]);

    const handleClickItem = useCallback(
      (extraData: DriversDeliveryExtraData) => {
        setSelectedRouteId(extraData.routeId ?? DEFAULT_UUIID_EMPTY);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={driversDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabDrivers;
